import { combineReducers, Action } from 'redux';
import settings from './Settings';
import auth from './Auth';
import message from './Message';
import common from './Common';
import user from './User';
import location from './Location';
import unit from './Unit';
import alert from './Alert';
import consumption from './Consumption';
import dashboard from './Dashboard';
import { RootState } from 'model/state';
import developerMenu from './DeveloperMenu'

const reducers = combineReducers({
  settings,
  auth,
  message,
  common,
  user,
  location,
  unit,
  alert,
  consumption,
  dashboard,
  developerMenu,
});


const rootReducer = (state: RootState | undefined, action: Action) => {
  return reducers(state, action);
}

export default rootReducer;
